let dev;
let urlPrefix;

if (location.hostname === 'h5.11visa.com') {
  dev = '';
  urlPrefix = '';
} else if (location.hostname === 'testh5.11visa.com') {
  dev = 'test';
  urlPrefix = 'test.';
} else {
  dev = 'dev';
  urlPrefix = 'dev.';
}

const exportDev = dev;
export default exportDev;

export const isLocalhost = ['192', 'localhost', '10'].some(
  (h) => location.hostname.indexOf(h) > -1,
);

export const env = {
  env: dev,
  urlPrefix,
  apiBase: `https://${dev}api.11visa.com`,
  // urlBase: `https://${dev}h5.11visa.com`,
  // pcUrl: `https://${urlPrefix || 'www.'}11visa.com`,
  // ossUrl: `https://${dev}o.11visa.com`,
};
